import React from 'react'
import { Box, IconButton, Typography } from '@mui/material';
import { DeleteSanadHistory } from '../../services/user/user';
import DeleteIcon from '@mui/icons-material/Delete';
import {  Confirm } from '../../utils/alert';
import { useTranslation } from 'react-i18next';

function HistoryCard({
  namesanad,
  datesabt,
  price,
  idstrsanad,
  onDelete // Receive the delete handler from parent
}) {
  const {t} = useTranslation();
  const handleDelete = async (id) => {
    const { value } = await Confirm((t("History.delT")), (t("History.delQ")),);
    if (value) {
      try {
        const response = await DeleteSanadHistory(id);
        if (response.status === 200) {
          onDelete(id); // Notify parent to remove the item

        }
      } catch (error) {
      }
  };
  }

  return (
    <Box sx={{borderColor:"#382145"}} className='flex border-2 rounded-md p-2 pb-4 my-3'>
      <div className='flex-grow flex flex-col gap-2 pr-4'>
        <Typography variant='h5' sx={{color:"#49454F"}}>{datesabt}</Typography>
        <Typography variant='h4'  sx={{color:"#3b3b3b"}}>{namesanad}</Typography>
      </div>
      <div className='flex items-center ml-4'>
        <IconButton 
          sx={{
            backgroundColor: "#C81D11",
            color: "white",
            border: "3px solid #f29791",
            '&:hover': {
              backgroundColor: "#a01810",  
            },
            '&:active': {
              backgroundColor: "#a01810",  
            },
          }}  
          onClick={() => handleDelete(idstrsanad)}
          aria-label='delete sanad'
        >
          <DeleteIcon fontSize="medium" />
        </IconButton>
      </div>
    </Box>  
  )
}

export default HistoryCard;
